import { render, staticRenderFns } from "./nfcPageAccess.vue?vue&type=template&id=4ece0811&scoped=true&"
import script from "./nfcPageAccess.vue?vue&type=script&lang=js&"
export * from "./nfcPageAccess.vue?vue&type=script&lang=js&"
import style0 from "./nfcPageAccess.vue?vue&type=style&index=0&id=4ece0811&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ece0811",
  null
  
)

export default component.exports